<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-prazo-pagamento') {
            next({ name: 'ven-prazo-pagamento-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-prazo-pagamento') {
            this.$router.push({ name: 'ven-prazo-pagamento-list' });
        }
    },
};
</script>
